var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "row my-4" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "my-4" }, [
          _c("h3", [_vm._v("แคมเปญแจก Coins")]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("a", { attrs: { href: _vm.apiUrl, target: "_blank" } }, [
            _c("img", {
              attrs: {
                height: "38",
                alt: "Line BeNeat",
                src: "/static/img/btn-line.png"
              }
            })
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n          เชื่อมต่อ Account BeNeat ของคุณกับ Line เพื่อรับ 50 Coins ฟรี!"
      ),
      _c("br")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f5a9e3c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f5a9e3c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/LineLoginCampaign.vue
// module id = 1644
// module chunks = 0